import { ShippingPage } from '@/app/pages/ShippingPage';

export function ResponsiveShippingPage() {
  return <ShippingPage />;
}
